import React, {useState} from "react";
import {useFieldArray, useFormContext} from "react-hook-form";

import {Button} from "@/components/button/Button.tsx";
import {Input} from "@/components/input/Input.tsx";
import {getFormError} from "@/lib/form/form.utils.ts";
import {FieldProps} from "@/pages/checks/components/form/fields/common.ts";

export const EmailListInput = ({name, ...rest}: FieldProps) => {
  const {
    getValues,
    control,
    clearErrors,
    setError,
    formState: {errors},
  } = useFormContext();
  const fieldError = getFormError(name, errors);
  const {prepend} = useFieldArray({control, name});
  const [inputValue, setInputValue] = useState("");
  const addHandler = (
    e:
      | React.FocusEvent<HTMLInputElement>
      | React.MouseEvent<HTMLButtonElement, MouseEvent>
      | React.KeyboardEvent<HTMLInputElement>
      | undefined
  ) => {
    e?.preventDefault();
    const newValue = inputValue.trim().toLowerCase();
    if (!newValue) {
      return;
    }
    const EMAIL_RE =
      /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/i;
    if (!EMAIL_RE.test(newValue)) {
      setError(name, {type: "manual", message: "Please enter a valid email address."});
      return;
    }
    if (!getValues(name).includes(newValue)) {
      prepend(newValue);
    }
    setInputValue("");
  };

  return (
    <div className="d-flex gap-2 flex-column flex-sm-row">
      <Input
        id={`${name}-input`}
        type="email"
        value={inputValue}
        onChange={({target}) => {
          setInputValue(target.value);
          clearErrors(name);
        }}
        onBlur={addHandler}
        onKeyDown={(e) => {
          if (e.key === "Enter") addHandler(e);
        }}
        placeholder="Enter email address"
        {...rest}
      />
      <Button onClick={addHandler} disabled={!inputValue || !!fieldError}>
        Add
      </Button>
    </div>
  );
};
